import React from 'react';
import { Container } from 'reactstrap';
import ProductiveCycleStageTemplateList from './ProductiveCycleStageTemplateList';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import UiContent from '../../Components/Common/UiContent';
import { icon } from 'leaflet';


//redux

const ProductiveCycleStageTemplate = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Producción', icon: 'icon-bubbles' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' }
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Etapas del Ciclo Productivo' links={breadcrumbLinks} icon={'icon-layout-list'} />
					<ProductiveCycleStageTemplateList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default ProductiveCycleStageTemplate;
